import React, { forwardRef, useEffect, useMemo, useState } from 'react';
import MaterialTable from '@material-table/core';
import flowRight from 'lodash.flowright';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import CustomTableTitle from '../../../partials/CustomTableTitle';
import tableColumns from './tableColumns';
import { mapTableOptions } from '../../../consts/tableOptions';
import useTableLocalization from '../../../utils/useTableLocalization';
import FilterButton from '../../../partials/tableCustomButtons/FilterButton';
import useLocalTableStore from '../../../utils/useLocalTableStore';
import { actions as reduxActions } from '../reducers';
import customTableIcons from '../../../partials/tableIcons/customTableIcons';
import onLicenceUpdate from '../actions/updateLicense';
import updateLicenses from '../actions/updateLicenses';
import CustomTableSaveButton from '../../../partials/tableIcons/CustomTableSaveButton';
import { getLicenses } from '../actions/getLicenses';
import RefreshButton from '../../../partials/tableCustomButtons/RefreshButton';

const LicensesTable = ({
  intl,
  licenses,
  columns,
  setColumns,
  getLicenses,
  connectClientId
}) => {
  const [filtering, setFiltering] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const { localization, language } = useTableLocalization();

  useEffect(() => {
    getLicenses(connectClientId);
    // eslint-disable-next-line
  }, [connectClientId]);

  useEffect(() => {
    if (refresh) {
      getLicenses(connectClientId);
      setRefresh(false);
    }
    // eslint-disable-next-line
  }, [refresh]);

  const tableDefaultColumns = useMemo(() => {
    return tableColumns();
  }, []);

  const { onChangeColumnHidden } = useLocalTableStore({
    tableName: 'Licenses',
    setColumns,
    tableDefaultColumns,
    language
  });

  const options = useMemo(() => {
    return {
      ...mapTableOptions({ exportData: false }),
      filtering,
      paging: false
    };
  }, [filtering]);

  const actions = useMemo(
    () => {
      let buttons = [
        {
          icon: () => <FilterButton />,
          onClick: () => {
            setFiltering(!filtering);
          },
          isFreeAction: true,
          tooltip: intl.formatMessage({ id: 'BUTTON.FILTER' })
        },
        {
          icon: () => <RefreshButton tableHeader={true} />,
          onClick: () => setRefresh(true),
          isFreeAction: true
        }
      ];

      return buttons;
    },
    // eslint-disable-next-line
    [filtering]
  );

  return (
    <div>
      <MaterialTable
        title={
          <CustomTableTitle
            text="MENU.LICENSES"
            icon={<i className="fas fa-file-certificate"></i>}
          />
        }
        icons={{
          ...customTableIcons,
          Check: forwardRef((props, ref) => (
            <CustomTableSaveButton ref={ref} {...props} />
          ))
        }}
        actions={actions}
        columns={columns}
        data={licenses}
        options={options}
        localization={localization}
        onChangeColumnHidden={onChangeColumnHidden}
        editable={{
          isEditHidden: rowData => rowData.type !== 'unit',
          onRowUpdate: async (newData, oldData) => {
            await onLicenceUpdate({
              component: oldData.component,
              quota: newData.quota
            });
          },
          onBulkUpdate: async changes => await updateLicenses({ changes })
        }}
      />
    </div>
  );
};
const mapStatesToProps = ({ licenses, selectClient }) => {
  return {
    ...licenses,
    connectClientId: selectClient.selectedClient.connect30_domain
  };
};

const mapDispatchToProps = {
  setColumns: reduxActions.setColumns,
  getLicenses
};

export default flowRight(
  injectIntl,
  connect(mapStatesToProps, mapDispatchToProps)
)(LicensesTable);
